module.exports = __webpack_public_path__ + "static/portfolio-1-e3782047f1ec6eb86e8b784da8debec5.jpg";